export const REDIRECT_COUNT = 'redirectCount';

export const IDENTITY_CSRF_TOKEN = 'avatar.csrf.token';
